<div class="footer">
<div class="content"> <p>All contents © Copyright J&J MedTech Services, Inc. 2024. All Rights Reserved.</p></div>
</div>